"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "prata-sannita": {
    "139cf909": [{
      "hkey": "9415b12d",
      "slug": "prata-sannita",
      "name": "Prata Sannita",
      "primary": true,
      "skipSearch": false
    }],
    "cerasa": [{
      "hkey": "9415b12d",
      "slug": "prata-sannita",
      "name": "Prata Sannita",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5d864a0b": [{
      "hkey": "9415b12d",
      "slug": "prata-sannita",
      "name": "Prata Sannita",
      "primary": true,
      "skipSearch": false
    }],
    "pantani": [{
      "hkey": "9415b12d",
      "slug": "prata-sannita",
      "name": "Prata Sannita",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "db032a15": [{
      "hkey": "a7fd56f0",
      "slug": "prata-sannita-centro",
      "name": "Prata Sannita Centro",
      "primary": true,
      "skipSearch": false
    }],
    "prata-sannita-inferiore": [{
      "hkey": "a7fd56f0",
      "slug": "prata-sannita-centro",
      "name": "Prata Sannita Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "prata-sannita"
    }],
    "511b64fd": [{
      "hkey": "a7fd56f0",
      "slug": "prata-sannita-centro",
      "name": "Prata Sannita Centro",
      "primary": true,
      "skipSearch": false
    }],
    "prata-sannita-superiore": [{
      "hkey": "a7fd56f0",
      "slug": "prata-sannita-centro",
      "name": "Prata Sannita Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "prata-sannita"
    }],
    "369e1f19": [{
      "hkey": "9415b12d",
      "slug": "prata-sannita",
      "name": "Prata Sannita",
      "primary": true,
      "skipSearch": false
    }],
    "rio": [{
      "hkey": "9415b12d",
      "slug": "prata-sannita",
      "name": "Prata Sannita",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;